// ============================================================
// KONFIGURASI UNDANGAN PERNIKAHAN
// Edit nilai-nilai di sini untuk mengubah detail undangan.
// ============================================================

export const WEDDING_CONFIG = {
  // --- Mempelai ---
  groom: {
    name: "Kevin Husada",
    firstName: "Kevin",
    initial: "K",
    parents: "Putra dari\nBpk. Budi Husada\n& Ibu Valery",
    instagram: "", // contoh: "kevin.husada"
  },
  bride: {
    name: "Angeline Wijaya",
    firstName: "Angeline",
    initial: "A",
    parents: "Putri dari\nBpk. Wendy Wijaya\n& Ibu Pauline",
    instagram: "",
  },

  // --- Tanggal & Waktu (format ISO, +07:00 = WIB) ---
  weddingDateISO: "2026-08-28T10:00:00+07:00",

  // --- Acara ---
  events: [
    {
      title: "Holy Matrimony",
      time: "10.00 WIB",
      venue: "JW Marriott Hotel Medan",
      address: "Jl. Putri Hijau No.10, Kesawan, Kec. Medan Bar., Kota Medan, Sumatera Utara 20111",
    },
    {
      title: "Wedding Reception",
      time: "19.00 WIB",
      venue: "JW Marriott Hotel Medan",
      address: "Jl. Putri Hijau No.10, Kesawan, Kec. Medan Bar., Kota Medan, Sumatera Utara 20111",
    },
  ],

  // Google Maps embed (search query) & directions link
  mapsQuery: "JW+Marriott+Hotel+Medan,Jl.+Putri+Hijau+No.10,Medan",
  mapsLink: "https://maps.app.goo.gl/8ZqWkCQfgQpFy9Sy5",

  // --- WhatsApp untuk RSVP / Ucapan / Konfirmasi ---
  // Format internasional tanpa + atau 0 di depan (62 = Indonesia)
  whatsappNumber: "6281251235100",

  // --- Rekening Amplop Digital ---
  accounts: [
    { bank: "BCA", number: "1275021350", name: "Kevin Husada" },
  ],

  // --- URL untuk Share WhatsApp (otomatis isi link halaman) ---
  inviteUrl: typeof window !== "undefined" ? window.location.origin : "",

  // --- Quote di Hero ---
  heroQuote: '"Two souls, one heart — bersatu dalam ikatan kasih yang abadi."',
  heroQuoteAttr: "— Medan, 2026",
};

// Convert weddingDateISO → Date object
export const WEDDING_DATE = new Date(WEDDING_CONFIG.weddingDateISO);

// Get guest name from URL `?to=Nama+Tamu`
export function getGuestName() {
  if (typeof window === "undefined") return "";
  const params = new URLSearchParams(window.location.search);
  const raw = params.get("to") || params.get("guest") || "";
  return raw.replace(/\+/g, " ").trim();
}

// Build WhatsApp wa.me URL with prefilled message
export function buildWhatsAppLink(message) {
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${WEDDING_CONFIG.whatsappNumber}?text=${encoded}`;
}
